import { bizApiWrapper } from '@web-publish-id/shared/http'
import { createPaymentLinkOrder } from '@web-publish-id/payment-shared/apis/payment'
import { PaymentComponent } from './payment'
import { PublishPaymentMethodItem } from '@web-publish-id/payment-shared/apis/types/payment'
import { PaymentComponentCreateLinkOptions } from '../types'
import { PAYMENT_COM_SDK_VERSION } from '../const/sdk'

/**
 * 支付组件链接支付
 */
export class PaymentComponentLink {
  paymentInstance: PaymentComponent
  methodConfig: PublishPaymentMethodItem
  options: PaymentComponentCreateLinkOptions

  constructor(
    paymentInstance: PaymentComponent,
    methodConfig: PublishPaymentMethodItem,
    options: PaymentComponentCreateLinkOptions
  ) {
    this.paymentInstance = paymentInstance
    this.methodConfig = methodConfig
    this.options = options || {}
  }

  /**
   * 创建链接支付订单
   * @param options 创建链接支付参数
   * @returns
   */
  async createOrder() {
    const { callback_url } = this.options
    const { sys_order_id } = this.paymentInstance.config
    const { payment_method_id, payment_channel_type } = this.methodConfig

    const res = await bizApiWrapper(
      createPaymentLinkOrder({
        callback_url: callback_url || undefined,
        payment_method_id,
        sys_order_id,
        payment_channel_type,
        os: 1,
        sdk_version: PAYMENT_COM_SDK_VERSION,
      })
    )

    return res
  }
}

export default PaymentComponentLink
